export const view = {
    methods: {
        retry: function(){
            this.$refs.ErrorForm.showForm(false);
            this.$refs.PayForm_DataCap.showForm(true);
        },
        tokenCallback: function (response) {
            var _self = this;
            if (response.Error) {
                this.$refs.LoaderForm.showForm(false);
                this.$refs.ErrorForm.showForm(true);
                document.querySelector('button[name=retry]').addEventListener('click', this.retry);
                var msg = _self.validateCardInformation();
                document.querySelector('span.description').innerHTML = msg;
            }
            else {
                var validToken = response.Token;
                document.getElementById('token').value = validToken;

                this.$refs.LoaderForm.showForm(true);
                var data = {
                    FranchiseID: localStorage.franchiseID,
                    MembershipUserID: localStorage.userMembershipID,
                    PaymentReference: _self.PaymentReference,
                    Token: validToken
                }
                _self.$ooApi.orders.payment.pay.token.v1(data).then(function (result) {
                    if(result.success)
                        _self.$router.push({ path: 'Success', query: { PaymentReference: _self.PaymentReference }});
                    else
                    _self.$router.push('Cancel')
                })
                
            }
        },
        payDataCap: function () {
            var _self = this;
            
            document.querySelector('button.pay').classList.add('disabled');
            window.DatacapWebToken.requestToken(_self.MerchantKey, 'payment_form', _self.tokenCallback);
            this.$refs.PayForm_DataCap.showForm(false);
            this.$refs.LoaderForm.showForm(true);
        },
        initPayTransactionJunction: function(){
            var _self = this;
            this.$refs.LoaderForm.showForm(true);
            window.eftSec.checkout.init({
                checkoutRedirect: true,
                paymentKey: _self.PaymentKey,
                paymentType: 'credit_card',
                cardOptions: {
                    rememberCard: true,
                    rememberCardDefaultValue: 1
                }
            });
            this.$refs.LoaderForm.showForm(false);
            document.querySelector('.banner-container').style.display = 'none';
        },
        cancel: function () {
            var _self = this;
            window.location.href = _self.CancelURL;
        },
        validateCardInformation: function () {
            var section = document.querySelector('form[name=PayForm_DataCap]');

            // Validate card number
            var cardNo = section.querySelector('input[data-token=card_number]').value;
            if (!window.DatacapWebToken.validateCardNumber(cardNo))
                    return 'Invalid card number, please try again.';

            // Validate expiration date
            var expMonth = section.querySelector('input[data-token=exp_month]').value;
            var expYear = section.querySelector('input[data-token=exp_year]').value;
            if (!window.DatacapWebToken.validateExpirationDate(expMonth, expYear))
                return 'Invalid expiration date, please try again.';

            return 'Error validating card information';

        }
    }
}